import { CollapsiblePanel } from '@shared/ui-react/CollapsiblePanel';
import { JsonToHtmlEl } from '@shared/utils/utils-html';
import { HARDCODED_PROPS } from '@shared/utils/utils';
import { observer } from 'mobx-react';
import * as React from 'react';
import { makeObservable, observable } from 'mobx';


@observer
export class ModelsSurfaceProps extends React.Component<{
    modelInfo: IModelPropsInfo;
}> {
    @observable openSubPanelKey = null;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    render() {
        if (this.props.modelInfo == null) {
            return <div>{__('js_logpoints.loading')}</div>
        }
        const { modelInfo } = this.props;
        let psetsMap = new Map<string, boolean>();
        const basicProps = [];
        const ifcStructPropsObj = {};

        if (modelInfo.isStructure && modelInfo.props) {
            let currentKey = '';
            Object.keys(modelInfo.props).forEach(key => {
                const value = modelInfo.props[key];
                if (key.startsWith('Set #')) {
                    currentKey = value as string;
                    ifcStructPropsObj[currentKey] = [];
                    psetsMap.set(currentKey, false);
                } else if (!!ifcStructPropsObj[currentKey]) {
                    ifcStructPropsObj[currentKey].push({ name: key, type: value });
                } else {
                    basicProps.push([key, value]);
                }
            })
        }

        return <div className='flex-column' style={{ marginLeft: 3 }}>
            {modelInfo.name ?
                <strong style={{ marginBottom: 3 }}>{modelInfo.name}</strong> :
                <div>{__('js_map.no_surface_selected')}</div>
            }
            {modelInfo.isStructure ?
                <div>
                    {basicProps.map(([key, val]) => <div key={key}>{key}: {val}</div>)}
                    {Object.keys(ifcStructPropsObj).map(key =>
                        <CollapsiblePanel key={key}
                                          label={key}
                                          animated={true}
                                          isSubPanel={true}
                                          isOpen={this.openSubPanelKey === key}
                                          onToggle={() => this.openSubPanelKey = this.openSubPanelKey === key ? null : key}
                                          defaultIsOpen={false}>
                            <div>{ifcStructPropsObj[key].map(e => <div key={e.name}>{e.name}: {e.type}</div>)}</div>
                        </CollapsiblePanel>)}
                </div>
                :
                (modelInfo.props && Object.keys(modelInfo.props).length) > 0 ?
                    <JsonToHtmlEl data={Object.fromEntries(Object.entries(modelInfo.props).filter(([k]) => !HARDCODED_PROPS.has(k)))} /> :
                    <>{modelInfo.name && <div>{__('general.none')}</div>}</>
            }
        </div>
    }
}
